module.exports = __webpack_public_path__ + "static/img/7.e6110fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/7.png
// module id = tqlS
// module chunks = 0